import { defineMessages } from "react-intl";

export default defineMessages({
  reach: {
    id: "gauge.reach",
    defaultMessage: "Reach",
  },
  seeJobs1HourSooner: {
    id: "gauge.seeJobs1HourSooner",
    defaultMessage: "<bonus>Bonus: </bonus>See jobs <bold>1h sooner</bold>",
  },
  seeJobs2HoursSooner: {
    id: "gauge.seeJobs2HoursSooner",
    defaultMessage: "<bonus>Bonus: </bonus>See jobs <bold>2h sooner</bold>",
  },
  becomeSuperTalent: {
    id: "gauge.becomeSuperTalent",
    defaultMessage: "<bonus>Bonus: </bonus>Become <bold>SuperTalent</bold> & unlock all advantages",
  },
  defaultPreHeading: {
    id: "gauge.defaultPreHeading",
    defaultMessage: "Keep it up!",
  },
  defaultPreSub: {
    id: "gauge.defaultPreSub",
    defaultMessage: "Your badge awaits",
  },
  default6Heading: {
    id: "gauge.default6Heading",
    defaultMessage: "You're on the right track!",
  },
  default6Sub: {
    id: "gauge.default6Sub",
    defaultMessage: "<bonus>Bonus: </bonus>See jobs <bold>1h sooner</bold>",
  },
  default7Heading: {
    id: "gauge.default7Heading",
    defaultMessage: "You're almost there!",
  },
  default7Sub: {
    id: "gauge.default7Sub",
    defaultMessage: "<bonus>Bonus: </bonus>See jobs <bold>2h sooner</bold>",
  },
  default8Heading: {
    id: "gauge.default8Heading",
    defaultMessage: "<gradient>You're a SuperTalent</gradient>",
  },
  default8Sub: {
    id: "gauge.default8Sub",
    defaultMessage: "Enjoy the <bold>full advantages</bold>!",
  },
  yourScore: {
    id: "superTalentMetrics.yourScore",
    defaultMessage: "Your score",
  },
});
